<template>
    <div class="block" >
        <img :src="bg" alt="">
    </div>
</template>

<script>
    export default {
        name: "notice",
        data() {
            return {
               bg: ''
            }
        },
        methods: {
            
        },
        mounted() {
            this.bg = this.$route.query.pic
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
img {
    width: 100%;
}

</style>